import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { formatCurrencyMoeda } from "../../utils/FormatarValores";

export const SERIES_DO_GRAFICO = [
  { chave: "caixa", nome: "Caixa", cor: "#3b82f6" },
  { chave: "despesas", nome: "Despesas", cor: "#ef4444" },
  { chave: "sobra", nome: "Sobra", cor: "#22c55e" },
];

export const SERIES_VISIVEIS_INICIAIS = {
  caixa: true,
  despesas: true,
  sobra: true,
};

const ALTURA_DO_GRAFICO = 300;

const formatarEixoEmReais = (valor) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 0,
  }).format(valor);
};

// Legenda própria: cada série é um botão que oculta ou restaura a linha.
// Tooltip e escala do eixo consideram só as linhas renderizadas.
const GraficoEvolucaoDespesas = ({
  dados,
  seriesVisiveis,
  onAlternarSerie,
}) => {
  const seriesAtivas = SERIES_DO_GRAFICO.filter(
    (serie) => seriesVisiveis[serie.chave],
  );

  return (
    <div>
      <div
        className="flex flex-wrap items-center justify-center gap-2 mb-3"
        role="group"
        aria-label="Séries do gráfico"
      >
        {SERIES_DO_GRAFICO.map((serie) => {
          const visivel = Boolean(seriesVisiveis[serie.chave]);

          return (
            <button
              key={serie.chave}
              type="button"
              aria-pressed={visivel}
              onClick={() => onAlternarSerie(serie.chave)}
              className={`inline-flex items-center gap-2 rounded-md border border-gray-200 px-3 py-1 text-sm transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${
                visivel
                  ? "text-gray-900"
                  : "text-gray-400 line-through opacity-60"
              }`}
            >
              <span
                aria-hidden="true"
                className="inline-block h-0.5 w-4"
                style={{ backgroundColor: serie.cor }}
              />
              <span>
                {serie.nome}
                {visivel ? "" : " (oculta)"}
              </span>
            </button>
          );
        })}
      </div>

      {seriesAtivas.length === 0 ? (
        <div
          className="flex items-center justify-center text-sm text-gray-500"
          style={{ height: ALTURA_DO_GRAFICO }}
        >
          Nenhuma série selecionada
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={ALTURA_DO_GRAFICO}>
          <LineChart data={dados}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="mes" />
            <YAxis tickFormatter={formatarEixoEmReais} />
            <Tooltip
              formatter={(valor) => formatCurrencyMoeda(valor)}
              labelFormatter={(rotulo) => `Competência: ${rotulo}`}
            />
            {seriesAtivas.map((serie) => (
              <Line
                key={serie.chave}
                type="monotone"
                dataKey={serie.chave}
                stroke={serie.cor}
                name={serie.nome}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default GraficoEvolucaoDespesas;
